import { Query } from '@cubejs-client/core';
import { DimensionBreakdownChart } from '.';
import { TOOLTIP_DEFINITIONS } from '../constants/tooltips';
import { CubeFilters, useChartMetric } from '../hooks';

export interface DenialsBreakdownChartProps {
  baseQuery: CubeFilters;
  dimensionSpec: { label: string; metric: string };
  sortByValue?: boolean;
}
export default function DenialsBreakdownChart(
  props: DenialsBreakdownChartProps,
) {
  const { baseQuery, dimensionSpec, sortByValue } = props;
  const { chartMetric } = useChartMetric();

  const query = {
    ...baseQuery,
    filters: [
      ...baseQuery.filters,
      {
        member: 'AdjudicatedClaims.denialStatus',
        operator: 'equals',
        values: ['full', 'partial'],
      },
    ],
  } satisfies Query;

  // Select appropriate tooltip based on dimension metric
  const getTooltip = () => {
    switch (dimensionSpec.metric) {
      case 'Claim.arAgeGroup':
        return TOOLTIP_DEFINITIONS.denial_charts.denials_breakdown_age;
      case 'AdjudicatedClaims.denialStatus':
        return TOOLTIP_DEFINITIONS.denial_charts.denials_breakdown_status;
      case 'Claim.adjudicationReasonCategory':
        return TOOLTIP_DEFINITIONS.denial_charts.denials_breakdown_ansi;
      default:
        return undefined;
    }
  };

  return (
    <DimensionBreakdownChart
      barSize={25}
      baseQuery={query}
      chartMetric={chartMetric}
      dimensionSpec={dimensionSpec}
      measureSpec={{
        count: { label: 'Denied Claims', metric: 'Claim.count' },
        dollar: {
          label: 'Denied Benefits',
          metric: 'AdjudicatedClaims.deniedBenefits',
        },
      }}
      sortByValue={sortByValue}
      tooltip={getTooltip()}
    />
  );
}
